<template>
  <div class="tween-number-container">
    <div class="tween-number-container--increase-body">
      <div class="progress-bar" :style="{ opacity: progressBarWidth }"></div>
      <label for="inputNumber">Escoge un número:</label>
      <div class="number-input">
        <button @click="decrement" class="btn">-</button>
          <div class="display">{{ tweened.number.toFixed(0) }}</div>
        <button @click="increment" class="btn">+</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, watch } from 'vue';
import gsap from 'gsap';

export default {
  name: 'TweenNumber',
  setup() {
    const number = ref(0);

    const tweened = reactive({
      number: 0,
    });

    const increment = () => {
      if (number.value < 500) {
        number.value += 25;
      }
    };

    const decrement = () => {
      if (number.value > 0) {
        number.value -= 25;
      }
    };

    const progressBarWidth = computed(() => {
      const percentage = (tweened.number / 500) * 100; // Basado en un máximo de 500
      return `${percentage}%`;
    });

    watch(number, (newVal) => {
      gsap.to(tweened, {
        duration: 0.5,
        number: Number(newVal) || 0,
      });
    });

    return {
      number,
      tweened,
      increment,
      decrement,
      progressBarWidth,
    };
  },
};
</script>

<style lang="scss" scoped>
.tween-number-container {
    align-items: center;
    border: 1px solid var(--line);
    border-radius: 24px;
    background:
      radial-gradient(circle, rgba(0,0,0,0.08) 1px, transparent 1px),
      linear-gradient(135deg, oklch(0.96 0.04 75) 0%, oklch(0.92 0.07 65) 100%);
    background-size: 20px 20px, cover;
    display: flex;
    flex-direction: column;
    height: 60vh;
    margin: 20px auto;
    max-width: 500px;
    max-height: 400px;
    padding: 48px 32px;
    position: relative;
    justify-content: center;
    text-align: center;
    width: 80vw;

    &--increase-body {
      align-items: center;
      color: #1a1a1a;
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: center;

    .progress-bar {
      bottom: 0;
      background-color: oklch(0.82 0.1 65);
      height: 100%;
      position: absolute;
      transition: all 0.3s ease-in-out;
      left: 0;
      width: 100%;
      z-index: -3;
      }
    }

  label {
    display: block;
    margin-bottom: 0.5rem;
  }

  .number-input {
    align-items: center;
    display: flex;
    gap: 24px;
    

    .btn {
      align-items: center;
      background: linear-gradient(
        160deg,
        rgba(255, 255, 255, 0.55) 0%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 200, 100, 0.2) 100%
      );
      backdrop-filter: blur(16px) saturate(1.8);
      -webkit-backdrop-filter: blur(16px) saturate(1.8);
      border: 1px solid rgba(255, 255, 255, 0.6);
      border-bottom-color: rgba(255, 255, 255, 0.2);
      border-right-color: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      box-shadow:
        0 8px 24px rgba(0, 0, 0, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8),
        inset 0 -1px 0 rgba(0, 0, 0, 0.06);
      color: rgba(60, 40, 10, 0.85);
      cursor: pointer;
      display: flex;
      font-size: 1.2rem;
      font-weight: bold;
      height: 64px;
      justify-content: center;
      padding: 15px;
      text-align: center;
      transition: all 0.2s ease;
      width: 64px;
      outline: none;

      &:focus { outline: none; }
      &:focus-visible { outline: none; }

      &:hover {
        background: linear-gradient(
          160deg,
          rgba(255, 255, 255, 0.7) 0%,
          rgba(255, 255, 255, 0.25) 50%,
          rgba(255, 200, 100, 0.3) 100%
        );
        box-shadow:
          0 12px 32px rgba(0, 0, 0, 0.15),
          0 4px 12px rgba(0, 0, 0, 0.1),
          inset 0 1px 0 rgba(255, 255, 255, 0.9),
          inset 0 -1px 0 rgba(0, 0, 0, 0.06);
      }

      &:active {
        transform: scale(0.93);
        box-shadow:
          0 4px 12px rgba(0, 0, 0, 0.1),
          inset 0 2px 6px rgba(0, 0, 0, 0.08),
          inset 0 1px 0 rgba(255, 255, 255, 0.6);
      }
    }

    .display {
      font-size: 2rem;
      font-weight: bold;
      width: 50px;
      text-align: center;
    }
  }

  p {
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 1rem;
  }
}
</style>